import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';

import { MatDialog } from '@angular/material/dialog';

import { ExcelService } from '../../services/excel.service';
import { ConsultaLogEstoqueProdutos } from 'src/app/interfaces/produtos.estoque';
import funcoesGerais from 'src/app/funcoes/funcoesGerais';

@Component({
  selector: 'app-relatorio-movimentacao-estoque',
  templateUrl: './relatorio-movimentacao-estoque.component.html',
  styleUrls: ['./relatorio-movimentacao-estoque.component.scss', '../../styles/estilo.padrao.scss', './impressao-relatorio.css']
})
export class RelatorioMovimentacaoEstoqueComponent implements OnInit {
  uid;
  bConsulta: boolean = false;
  bCaracterEspecial: boolean = false;
  sNomeProduto: string = '';
  produtoSelecionado: any;
  range: FormGroup;
  datePickerRotaControl: FormControl;

  contAcrDec: number = 0;
  contQuantidadeComprada: number = 0;
  contSaldoFinal: number = 0;


  registros: ConsultaLogEstoqueProdutos[] = [];

  maxDate: Date = new Date();
  minDate: Date = new Date();
  today: Date = new Date();

  $consulta;
  produtos = [];
  auxObservableNomesProdutos;

  tipoCadastro = 'Vendedor';

  constructor(
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private excelService: ExcelService,
    private af: AngularFireAuth

  ) {
    this.uid = localStorage.getItem('uid');

    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.tipoCadastro = 'Vendedor';
      } else
        this.tipoCadastro = 'Admin';
    });

    const currentYear = new Date().getFullYear();
    this.minDate = new Date(2021, 0, 1);
  }

  ngOnInit(): void {
    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });

    this.datePickerRotaControl = new FormControl(new Date());

    //this.range.get('start').patchValue(new Date(2021, 10, 1));
    this.range.get('start').patchValue(new Date());
    this.range.get('end').patchValue(new Date());
  }

  buscarRelatorioMovimentacaoPeriodo() {
    this.spinner.show('relatorio-movimentacao-estoque');
    let timestampInicio: Date = new Date(this.range.get('start').value);
    timestampInicio.setHours(0);
    timestampInicio.setMinutes(0);
    timestampInicio.setSeconds(0);
    timestampInicio.setMilliseconds(0);

    let timestampFinal: Date = new Date(this.range.get('end').value);
    timestampFinal.setHours(23);
    timestampFinal.setMinutes(59);
    timestampFinal.setSeconds(59);
    timestampFinal.setMilliseconds(999);
    let difference = (timestampInicio.getFullYear() * 12 + timestampInicio.getMonth()) - (timestampFinal.getFullYear() * 12 + timestampFinal.getMonth());

    if (difference >= -12) {
      if (this.produtoSelecionado) {
        this.registros = [];
        this.contAcrDec = 0;
        this.contQuantidadeComprada = 0;
        this.$consulta = this.usuarioService.getEstoqueProdutoTimestamp(this.produtoSelecionado.Key, timestampInicio.getTime(), timestampFinal.getTime()).pipe(take(1)).subscribe(snap => {

          this.usuarioService.getEstoqueProduto(this.produtoSelecionado.Key).pipe(take(1)).subscribe(quantidadeEstoque => {
            if (quantidadeEstoque)
              this.produtoSelecionado.QuantidadeEstoque = quantidadeEstoque;
            else
              this.produtoSelecionado.QuantidadeEstoque = 0;

            if (snap.length > 0) {
              let dados: ConsultaLogEstoqueProdutos;

              snap.forEach((item, index) => {
                dados = item.payload.val() as ConsultaLogEstoqueProdutos;

                dados.Data = funcoesGerais.tratarData(dados.Timestamp);
                dados.Hora = funcoesGerais.tratarHora(dados.Timestamp);

                switch (dados.Tipo) {
                  case 'Venda':
                    //@ts-ignore
                    dados.Tipo = `Venda (${dados.Pedido})`;
                    break;

                  case 'Estorno (Pedido Cancelado)':
                    //@ts-ignore
                    dados.Tipo = `Estorno (Pedido Cancelado - ${dados.Pedido})`;
                    break;
                }

                this.registros.push(dados);
              });
            }

            this.gerarRelatorio();
          });
        }); //.getConferenciaEstoqueTimestamp
      } else {
        this.toastr.warning('Informe um produto para realizar a busca', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
        setTimeout(() => this.spinner.hide('relatorio-movimentacao-estoque'), 300);
      }
    } else {
      this.toastr.warning('Não é possível realizar um filtro acima de 12 meses!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('relatorio-movimentacao-estoque'), 300);
    }
  }

  tratarCorLinha(i) {
    let sCorLinha = '';
    sCorLinha = i % 2 ? 'linha_cinza_tabela' : '';
    sCorLinha = this.registros[i].Tipo.includes('Estorno (Pedido Cancelado') || this.registros[i].Tipo === 'Estorno (Pedido Incompleto)' || this.registros[i].Tipo === 'Saída' ? 'linha_vermelha_tabela' : sCorLinha;
    return sCorLinha;
  }

  gerarRelatorio() {
    console.log('gerarRelatorio')

    let auxImpressao = '';
    let auxRegistros = '';
    let windowPopup;

    const registros = this.registros;

    for (let i = 0; i < registros.length; i++) {
      auxRegistros = auxRegistros +
        '<tr class="' + this.tratarCorLinha(i) + ' align_center_sem_weight">' +
        '<td><div style="display: inline-block; ">' + registros[i].Data + '</div></td>' +
        '<td><div style="margin-left: 5px; display: inline-block">' + registros[i].Hora + '</div></td>' +
        '<td><div style="margin-left: 5px; display: inline-block">' + registros[i].Tipo + '</div></td>' +
        '<td><div style="margin-left: 10px; display: inline-block">' + registros[i].AcrescimoDecrescimoControleGerenciar + '</div></td>' +
        '<td><div style="margin-left: 10px; display: inline-block">' + registros[i].QuantidadeEstoqueAposOperacao + '</div></td>' +
        '</tr>'
    }

    let header =
      '<div class="row">' //1
      + '<div class="col-sm text-center titulo">' //1
      + 'Movimentação do item: ' + this.produtoSelecionado.Nome
      //Fecha col-sm //1
      + '</div>'
      //Fecha row //1
      + '</div>'
      //Sub título
      + '<div class="row">' //2
      + '<div class="col-sm text-center subtitulo">' //2
      + 'Período analisado: ' + this.usuarioService.tratarData(new Date(this.range.get('start').value).getTime()) + ' até ' + this.usuarioService.tratarData(new Date(this.range.get('end').value).getTime())
      //Fecha col-sm //2
      + '</div>'
      //Fecha row //2
      + '</div>'

    let tabelaInformacoesGerais =
      '<div class="row mt-4">' //1
      + '<div class="col-sm text-center titulo">' //1
      + 'Informações gerais'
      //Fecha col-sm //1
      + '</div>'
      //Fecha row //1
      + '</div>'

      //Inicio ROW
      + '<div class="row mt-2">'
      //Inicio col-sm
      + '<div class="col-3 text-center">'
      + 'Valor Atual: ' + this.produtoSelecionado.ValorString
      //Fechamento col-sm
      + '</div>'
      //Inicio col-sm
      + '<div class="col-3 text-center">'
      + 'Quantidade Estoque: ' + this.produtoSelecionado.QuantidadeEstoque
      //Fechamento col-sm
      + '</div>'
      //Inicio col-sm
      + '<div class="col-3 text-center">'
      + 'Código do produto: ' + this.produtoSelecionado.CodigoProduto
      //Fechamento col-sm
      + '</div>'
      //Inicio col-sm
      + '<div class="col-3 text-center">'
      + 'Grupo: ' + this.produtoSelecionado.Grupo
      //Fechamento col-sm
      + '</div>'
      //Fechamento ROW
      + '</div>'

    let notasInformativas =
      '<div class="row mt-4">' //1
      + '<div class="col-sm notas_imformativas">' //1
      + '* Estoque estornado após "Verificar Estoque" - Por compra cancelada ou compra não finalizada pelo usuário.'
      //Fecha col-sm //1
      + '</div>'
      //Fecha row //1
      + '</div>'
      + '<div class="row mt-1">' //2
      + '<div class="col-sm notas_imformativas">' //2
      + '* Apenas linhas coloridas foram confirmadas o estorno.'
      //Fecha col-sm //2
      + '</div>'
      //Fecha row //
      + '</div>'

    auxImpressao =
      //Inicio ROW
      '<div class="row mt-3">' +
      //HEADER
      '<div class="col-sm text-center">' +
      '<table class="minimalistBlack">' +
      '<tbody>' +
      //LINHA 1 FIM
      //LINHA 2 HEADER
      '<tr class="align_center">' +
      '<td>Data</td>' +
      '<td>Hora</td>' +
      '<td>Tipo</td>' +
      '<td>Acr. / Decr.</td>' +
      '<td>Saldo</td>' +
      '</tr>' +
      //LINHA 2 HEADER FIM
      //LINHA 3 LOOP Produtos e descrições
      auxRegistros +
      '</tbody>' +
      '</table>' +
      //Fechamento col-sm
      '</div>' +
      //Fechamento ROW
      '</div>'

    windowPopup = window.open('Pedido', '_blank', '');
    windowPopup.document.open();

    windowPopup.document.write(
      '<html style="width: auto; margin: 16px">'
      + '<head>'
      + '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous"/>'
      + '</head>'
      + '<style>'
      + '/*Força css impressão chrome*/body {    -webkit-print-color-adjust: exact !important;}/*Customizações*/.linha_cinza_tabela {    background-color: #dfdfdf;}.linha_vermelha_tabela {    background-color: #faf0e6;}.align_center {    text-align: center;    font-weight: 700;}.align_center_sem_weight {    text-align: center;}.subtitulo {    font-size: xx-small;}.titulo {    font-size: large;    font-weight: 600;}.notas_imformativas{    font-size: 11px;}@page {    size: landscape;}/*TABELA BOOTSTRAP*/table.minimalistBlack {    border: 2px solid #000000;    width: 100%;    text-align: left;}table.minimalistBlack td,table.minimalistBlack th {    border: 1px solid #000000;    padding: 5px 5px;}table.minimalistBlack tbody td {    font-size: 13px;}table.minimalistBlack thead {    border-bottom: 2px solid #000000;}table.minimalistBlack thead th {    font-size: 15px;    font-weight: bold;    color: #000000;    text-align: center;}table.minimalistBlack tfoot {    font-size: 14px;    font-weight: bold;    color: #000000;    border-top: 2px solid #000000;}table.minimalistBlack tfoot td {    font-size: 14px;}'
      + '</style>'
      // + '<style>table.minimalistBlack {  border: 2px solid #000000;  width: 100%;  text-align: left;}table.minimalistBlack td, table.minimalistBlack th {  border: 1px solid #000000;  padding: 5px 5px;}table.minimalistBlack tbody td {  font-size: 13px;}table.minimalistBlack thead {    border-bottom: 2px solid #000000;}table.minimalistBlack thead th {  font-size: 15px;  font-weight: bold;  color: #000000;  text-align: center;}table.minimalistBlack tfoot {  font-size: 14px;  font-weight: bold;  color: #000000;  border-top: 2px solid #000000;}table.minimalistBlack tfoot td {  font-size: 14px;}</style>'
      + '<body>'
      + header
      + tabelaInformacoesGerais
      + notasInformativas
      + auxImpressao
      + '</body>'
      + '</html>'
    );

    setTimeout(() => {
      windowPopup.document.close();
      windowPopup.focus();
      windowPopup.print();
    }, 150);
    //windowPopup.close();

    this.spinner.hide('relatorio-movimentacao-estoque');
  }

  //Limita o período selecionado à 40 dias
  dateChanged(event) {
    let auxDate = new Date(event.value);
    auxDate.setDate(auxDate.getDate() + 360);

    if (auxDate.getTime() < this.today.getTime()) {
      this.maxDate = auxDate;
    } else {
      this.maxDate = this.today;
    }
  }

  onChangeNomeProduto(e) {
    if (e.length >= 4) {
      this.auxObservableNomesProdutos = this.usuarioService.getBuscaInicioNomeProduto(this.uid, e.toLowerCase()).subscribe(snap => {
        let dados;
        this.produtos = [];

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.NomeBusca.includes(e.toLowerCase())) {
            this.produtos.push({
              Key: item.key,
              Status: dados.Status,
              URL_Imagem: dados.URL_Imagem,
              DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
              //Parte 1
              TipoItem: dados.TipoItem,
              Unidade: dados.Unidade,
              IDUnidade: dados.IDUnidade,
              Nome: dados.Nome,
              NomeBusca: dados.NomeBusca,
              Grupo: dados.Grupo,
              IDGrupo: dados.IDGrupo,
              IDFornecedorPreferencial: dados.IDFornecedorPreferencial,
              CodigoBarras: dados.CodigoBarras,
              DescricaoComplementar: dados.DescricaoComplementar,
              Referencia: dados.Referencia,
              //Parte 2
              Valor: dados.Valor,
              ValorString: 'R$ ' + (dados.Valor).toFixed(2).replace('.', ','),
              ValorAtacado: dados.ValorAtacado,
              QuantidadeAtacado: dados.QuantidadeAtacado,
              QuantidadeEstoque: dados.QuantidadeEstoque,
              QuantidadeMinimaAlertaEstoque: dados.QuantidadeMinimaAlertaEstoque,
              QuantidadeMinima: dados.QuantidadeMinima,
              QuantidadeMaxima: dados.QuantidadeMaxima,
              Identificador: dados.Identificador,
              CodigoProduto: dados.CodigoProduto, // Fazer em função em nuvem ou cadastro posterior
              LucroBruto: dados.LucroBruto,
              Comissao: dados.Comissao,
              CustoCompra: dados.CustoCompra,
              CustoMedio: dados.CustoMedio,
              //Parte 5
              ValorPromocional: dados.ValorPromocional,
              TimestampInicialPromocional: dados.TimestampInicialPromocional,
              TimestampFinalPromocional: dados.TimestampFinalPromocional,
              //Demais parâmetros
              TimestampCadastro: dados.TimestampCadastro
            });
          }
        });
      });
    }
  }

  selecionarProduto(prod) {
    this.produtoSelecionado = prod;
  }

  omit_special_char(event) {
    let k;
    k = event.charCode;

    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 44 || k == 47) {
      return true;
    } else {
      this.bCaracterEspecial = true;
      return false;
    }
  }

}